"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETHClient = exports.FEE_MULTIPLIER = void 0;
const CarbonSDK_1 = __importDefault(require("../CarbonSDK"));
const constant_1 = require("../constant");
const eth_1 = require("../eth");
const util_1 = require("../util");
const address_1 = require("../util/address");
const blockchain_1 = require("../util/blockchain");
const generic_1 = require("../util/generic");
const number_1 = require("../util/number");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const ethers_1 = require("ethers");
exports.FEE_MULTIPLIER = ethers_1.ethers.BigNumber.from(2);
class ETHClient {
    constructor(configProvider, blockchain, tokenClient) {
        this.configProvider = configProvider;
        this.blockchain = blockchain;
        this.tokenClient = tokenClient;
    }
    static instance(opts) {
        const { configProvider, blockchain, tokenClient } = opts;
        if (!ETHClient.SUPPORTED_BLOCKCHAINS.includes(blockchain))
            throw new Error(`unsupported blockchain - ${blockchain}`);
        return new ETHClient(configProvider, blockchain, tokenClient);
    }
    getExternalBalances(api, address, whitelistDenoms) {
        return __awaiter(this, void 0, void 0, function* () {
            const tokenQueryResults = yield api.token.getAllTokens();
            const lockProxyAddress = this.getLockProxyAddress().toLowerCase();
            const tokens = tokenQueryResults.filter((token) => (0, blockchain_1.blockchainForChainId)(token.chainId.toNumber()) == this.blockchain &&
                token.tokenAddress.length == 40 &&
                token.bridgeAddress.toLowerCase() == (0, generic_1.stripHexPrefix)(lockProxyAddress) &&
                (!whitelistDenoms || whitelistDenoms.includes(token.denom)) &&
                this.verifyChecksum((0, generic_1.appendHexPrefix)(token.tokenAddress)));
            const assetIds = tokens.map((token) => {
                return this.verifyChecksum((0, generic_1.appendHexPrefix)(token.tokenAddress));
            });
            const provider = this.getProvider();
            const contractAddress = this.getBalanceReaderAddress();
            const contract = new ethers_1.ethers.Contract(contractAddress, eth_1.ABIs.balanceReader, provider);
            const checkSumAddr = ethers_1.ethers.utils.getAddress(address);
            const balances = yield contract.getBalances(checkSumAddr, assetIds);
            const TokensWithExternalBalance = [];
            for (let i = 0; i < assetIds.length; i++) {
                if (!tokens[i])
                    continue;
                TokensWithExternalBalance.push(Object.assign(Object.assign({}, tokens[i]), { externalBalance: balances[i].toString() }));
            }
            return TokensWithExternalBalance;
        });
    }
    approveERC20(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { token, gasPriceGwei, gasLimit, ethAddress, spenderAddress, signer } = params;
            const contractAddress = token.tokenAddress;
            const rpcProvider = this.getProvider();
            const contract = new ethers_1.ethers.Contract(contractAddress, eth_1.ABIs.erc20, rpcProvider);
            const nonce = yield rpcProvider.getTransactionCount(ethAddress);
            const approveResultTx = yield contract.connect(signer).approve(spenderAddress !== null && spenderAddress !== void 0 ? spenderAddress : token.bridgeAddress, ethers_1.ethers.constants.MaxUint256, {
                nonce,
                gasPrice: gasPriceGwei.shiftedBy(9).toString(10),
                gasLimit: gasLimit.toString(10),
            });
            return approveResultTx;
        });
    }
    checkAllowanceERC20(token, owner, spender) {
        return __awaiter(this, void 0, void 0, function* () {
            const contractAddress = token.tokenAddress;
            const rpcProvider = this.getProvider();
            const contract = new ethers_1.ethers.Contract(contractAddress, eth_1.ABIs.erc20, rpcProvider);
            const allowance = yield contract.allowance(owner, spender);
            return new bignumber_js_1.default(allowance.toString());
        });
    }
    bridgeTokens(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { fromToken, toToken, amount, toAddress, fromAddress, recoveryAddress, signer, gasPriceGwei, gasLimit, feeAmount, signCompleteCallback } = params;
            const networkConfig = this.getNetworkConfig();
            const rpcProvider = this.getProvider();
            if (!recoveryAddress.match(/^swth[a-z0-9]{39}$/)) {
                throw new Error("Invalid recovery address");
            }
            const fromTokenId = fromToken.id;
            const fromTokenAddress = (0, generic_1.appendHexPrefix)(fromToken.tokenAddress);
            const toTokenDenom = toToken.denom;
            const recoveryAddressHex = ethers_1.ethers.utils.hexlify(util_1.AddressUtils.SWTHAddress.getAddressBytes(recoveryAddress, CarbonSDK_1.default.Network.MainNet));
            const fromAssetHash = ethers_1.ethers.utils.hexlify(ethers_1.ethers.utils.toUtf8Bytes(fromTokenId));
            const toAssetHash = ethers_1.ethers.utils.hexlify(ethers_1.ethers.utils.toUtf8Bytes(toTokenDenom));
            const nonce = yield rpcProvider.getTransactionCount(fromAddress);
            const contract = new ethers_1.ethers.Contract(this.getBridgeEntranceAddr(), eth_1.ABIs.bridgeEntrance, rpcProvider);
            const feeAddress = (0, generic_1.appendHexPrefix)(networkConfig.feeAddress);
            const tokenCreator = fromToken.creator;
            const targetAddressBytes = util_1.AddressUtils.SWTHAddress.getAddressBytes(tokenCreator, CarbonSDK_1.default.Network.MainNet);
            const targetProxyHash = ethers_1.ethers.utils.hexlify(targetAddressBytes);
            const ethAmount = fromToken.tokenAddress === constant_1.NativeTokenHash ? amount : number_1.BN_ZERO;
            const bridgeResultTx = yield contract.connect(signer).lock(fromTokenAddress, // the asset to deposit (from) (0x00 if eth)
            [
                targetProxyHash,
                recoveryAddressHex,
                fromAssetHash,
                feeAddress,
                toAddress,
                toAssetHash, // _toAssetHash
            ], [
                amount.toString(10),
                feeAmount.toString(10),
                amount.toString(10)
            ], // callAmount
            {
                gasLimit: gasLimit.toString(10),
                gasPrice: gasPriceGwei.shiftedBy(9).toString(10),
                nonce,
                value: ethAmount.toString(10),
            });
            signCompleteCallback === null || signCompleteCallback === void 0 ? void 0 : signCompleteCallback();
            return bridgeResultTx;
        });
    }
    lockDeposit(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { address, token, amount, gasPriceGwei, gasLimit, ethAddress, signer, signCompleteCallback } = params;
            if (gasLimit.lt(150000)) {
                throw new Error("Minimum gas required: 150,000");
            }
            const networkConfig = this.getNetworkConfig();
            const assetId = (0, generic_1.appendHexPrefix)(token.tokenAddress);
            const targetProxyHash = (0, generic_1.appendHexPrefix)(this.getTargetProxyHash(token));
            const feeAddress = (0, generic_1.appendHexPrefix)(networkConfig.feeAddress);
            const toAssetHash = ethers_1.ethers.utils.hexlify(ethers_1.ethers.utils.toUtf8Bytes(token.id));
            const swthAddress = ethers_1.ethers.utils.hexlify(address);
            const contractAddress = this.getLockProxyAddress();
            const rpcProvider = this.getProvider();
            const nonce = yield rpcProvider.getTransactionCount(ethAddress);
            const contract = new ethers_1.ethers.Contract(contractAddress, eth_1.ABIs.lockProxy, rpcProvider);
            const lockResultTx = yield contract.connect(signer).lock(assetId, // _assetHash
            targetProxyHash, // _targetProxyHash
            swthAddress, // _toAddress
            toAssetHash, // _toAssetHash
            feeAddress, // _feeAddress
            [
                // _values
                amount.toString(),
                "0",
                amount.toString(), // callAmount
            ], Object.assign({ nonce, value: "0", gasPrice: gasPriceGwei.shiftedBy(9).toString(10), gasLimit: gasLimit.toString(10) }, (token.tokenAddress === "0000000000000000000000000000000000000000" && {
                value: amount.toString(),
            })));
            signCompleteCallback === null || signCompleteCallback === void 0 ? void 0 : signCompleteCallback();
            return lockResultTx;
        });
    }
    getDepositContractAddress(swthBech32Address, ownerEthAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const network = this.getNetworkConfig().network;
            const addressBytes = address_1.SWTHAddress.getAddressBytes(swthBech32Address, network);
            const swthAddress = ethers_1.ethers.utils.hexlify(addressBytes);
            const provider = this.getProvider();
            const contractAddress = this.getLockProxyAddress();
            // logger("getDepositContractAddress lock proxy", contractAddress)
            const contract = new ethers_1.ethers.Contract(contractAddress, eth_1.ABIs.lockProxy, provider);
            const walletAddress = yield contract.getWalletAddress(ownerEthAddress, swthAddress, this.getWalletBytecodeHash());
            // logger("getDepositContractAddress", swthBech32Address, ownerEthAddress, walletAddress)
            return walletAddress;
        });
    }
    sendDeposit(tokenWithExternalBalances, swthAddress, ethAddress, getSignatureCallback, overrideFee) {
        return __awaiter(this, void 0, void 0, function* () {
            const depositAddress = yield this.getDepositContractAddress(swthAddress, ethAddress);
            // TODO: Remove overrideFee when hydrogen feeQuote is deployed on production
            let feeAmount = yield this.getDepositFeeAmount(tokenWithExternalBalances, depositAddress);
            if (overrideFee) {
                feeAmount = overrideFee;
            }
            const amount = ethers_1.ethers.BigNumber.from(tokenWithExternalBalances.externalBalance);
            if (amount.lt(feeAmount)) {
                return "insufficient balance";
            }
            const networkConfig = this.getNetworkConfig();
            const assetId = (0, generic_1.appendHexPrefix)(tokenWithExternalBalances.tokenAddress);
            const targetProxyHash = (0, generic_1.appendHexPrefix)(this.getTargetProxyHash(tokenWithExternalBalances));
            const feeAddress = (0, generic_1.appendHexPrefix)(networkConfig.feeAddress);
            const toAssetHash = ethers_1.ethers.utils.hexlify(ethers_1.ethers.utils.toUtf8Bytes(tokenWithExternalBalances.id));
            const nonce = Math.floor(Math.random() * 1000000000); // random nonce to prevent replay attacks
            const message = ethers_1.ethers.utils.solidityKeccak256(["string", "address", "bytes", "bytes", "bytes", "uint256", "uint256", "uint256"], ["sendTokens", assetId, targetProxyHash, toAssetHash, feeAddress, amount, feeAmount, nonce]);
            // logger("sendDeposit message", message)
            let signatureResult;
            const { address, signature } = yield getSignatureCallback(message);
            const signatureBytes = ethers_1.ethers.utils.arrayify((0, generic_1.appendHexPrefix)(signature));
            const rsv = ethers_1.ethers.utils.splitSignature(signatureBytes);
            // logger("sign result", address, signature)
            signatureResult = {
                owner: address,
                v: rsv.v.toString(),
                r: rsv.r,
                s: rsv.s,
            };
            const network = this.getNetworkConfig().network;
            const addressBytes = address_1.SWTHAddress.getAddressBytes(swthAddress, network);
            const swthAddressHex = ethers_1.ethers.utils.hexlify(addressBytes);
            const body = {
                owner_address: signatureResult.owner,
                swth_address: swthAddressHex,
                token_address: assetId,
                token_creator: targetProxyHash,
                token_denom: tokenWithExternalBalances.denom,
                token_id: tokenWithExternalBalances.id,
                amount: amount.toString(),
                fee_amount: feeAmount.toString(),
                fee_address: feeAddress,
                nonce: nonce.toString(),
                v: signatureResult.v,
                r: signatureResult.r,
                s: signatureResult.s,
                blockchain: this.blockchain,
            };
            const result = yield fetch(this.getPayerUrl() + "/deposit", { method: "POST", body: JSON.stringify(body) });
            // logger("fetch result", result)
            return result;
        });
    }
    getDepositFeeAmount(token, depositAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const feeInfo = yield this.tokenClient.getFeeInfo(token.denom);
            if (!feeInfo.deposit_fee) {
                throw new Error("unsupported token");
            }
            if ((0, blockchain_1.blockchainForChainId)(token.chainId.toNumber()) !== this.blockchain) {
                throw new Error("unsupported token");
            }
            let feeAmount = ethers_1.ethers.BigNumber.from(feeInfo.deposit_fee);
            const walletContractDeployed = yield this.isContract(depositAddress);
            if (!walletContractDeployed) {
                feeAmount = feeAmount.add(ethers_1.ethers.BigNumber.from(feeInfo.create_wallet_fee));
            }
            return feeAmount;
        });
    }
    isContract(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const provider = this.getProvider();
            const code = yield provider.getCode(address);
            // non-contract addresses should return 0x
            return code !== "0x";
        });
    }
    retrieveERC20Info(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const provider = this.getProvider();
            const contract = new ethers_1.ethers.Contract(address, eth_1.ABIs.erc20, provider);
            const decimals = yield contract.decimals();
            const name = yield contract.name();
            const symbol = yield contract.symbol();
            return { address, decimals, name, symbol };
        });
    }
    formatWithdrawalAddress(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const isValidAddress = ethers_1.ethers.utils.isAddress(address);
            if (!isValidAddress) {
                throw new Error("invalid address");
            }
            const isContract = yield this.isContract(address);
            if (isContract) {
                throw new Error("cannot withdraw to contract address");
            }
            return address.substr(2);
        });
    }
    getEthSigner(privateKey) {
        return new ethers_1.ethers.Wallet(privateKey, this.getProvider());
    }
    sign(message, privateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const ethWallet = this.getEthSigner(privateKey);
            const messageBytes = ethers_1.ethers.utils.arrayify(message);
            const signatureBytes = yield ethWallet.signMessage(messageBytes);
            const signature = ethers_1.ethers.utils.hexlify(signatureBytes).replace(/^0x/g, "");
            return {
                address: ethWallet.address,
                signature,
            };
        });
    }
    /**
     * TargetProxyHash is a hash of token originator address that is used
     * for lockproxy asset registration and identification
     *
     * @param token
     */
    getTargetProxyHash(token) {
        const networkConfig = this.getNetworkConfig();
        const addressBytes = address_1.SWTHAddress.getAddressBytes(token.creator, networkConfig.network);
        const addressHex = (0, generic_1.stripHexPrefix)(ethers_1.ethers.utils.hexlify(addressBytes));
        return addressHex;
    }
    getProvider() {
        return new ethers_1.ethers.providers.JsonRpcProvider(this.getProviderUrl());
    }
    getNetworkConfig() {
        return this.configProvider.getConfig();
    }
    getConfig() {
        const networkConfig = this.getNetworkConfig();
        const blockchain = this.blockchain;
        return networkConfig[ETHClient.BLOCKCHAIN_KEY[blockchain]];
    }
    getPayerUrl() {
        return this.getConfig().payerURL;
    }
    getProviderUrl() {
        return this.getConfig().rpcURL;
    }
    getLockProxyAddress() {
        return this.getConfig().lockProxyAddr;
    }
    getBalanceReaderAddress() {
        return this.getConfig().balanceReader;
    }
    getWalletBytecodeHash() {
        return this.getConfig().byteCodeHash;
    }
    getBridgeEntranceAddr() {
        return this.getConfig().bridgeEntranceAddr;
    }
    /**
     * verify that address is a valid checksum.
     * Returns checksum address if valid, returns undefined if invalid
     * @input address to be verified
     */
    verifyChecksum(input) {
        try {
            return ethers_1.ethers.utils.getAddress(input);
        }
        catch (_a) { }
    }
}
exports.ETHClient = ETHClient;
ETHClient.SUPPORTED_BLOCKCHAINS = [blockchain_1.Blockchain.BinanceSmartChain, blockchain_1.Blockchain.Ethereum];
ETHClient.BLOCKCHAIN_KEY = {
    [blockchain_1.Blockchain.BinanceSmartChain]: "bsc",
    [blockchain_1.Blockchain.Ethereum]: "eth",
};
exports.default = ETHClient;
